var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FormBaseElement } from '@unitarius/xbpm-runtime';
import { mapElementClass } from '../../common/utils/element.utils';
var ExtensionContainer = /** @class */ (function (_super) {
    __extends(ExtensionContainer, _super);
    function ExtensionContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getClass = function (options) {
            var isPrintable = options.isPrintable;
            var className = mapElementClass(options) + (isPrintable === false ? 'HideForPrint' : '');
            return !!className ? { className: className } : {};
        };
        return _this;
    }
    ExtensionContainer.prototype.elementRender = function (def) {
        var _a = def.frontOptions, isPrintableHeader = _a.isPrintableHeader, header = _a.header, headerStyle = _a.headerStyle;
        return (def.hidden ? (null) : React.createElement("div", __assign({ key: def.id, id: def.id }, this.getClass(def.frontOptions)),
            React.createElement("div", { className: 'p-col' + (isPrintableHeader === false ? ' HideForPrint' : '') + ' title-panel title-panel--extension', style: headerStyle || {} }, def.header || header),
            this.renderChildren()));
    };
    return ExtensionContainer;
}(FormBaseElement));
export { ExtensionContainer };
//# sourceMappingURL=Extension.js.map